import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 23 19",
  "content": "<symbol viewBox=\"0 0 23 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"heart\">\n<path d=\"M9.7756 2.59706L11.453 4.37869C11.4785 4.40574 11.5215 4.40574 11.547 4.37869L13.2244 2.59706C15.0609 0.646479 18.1613 0.646478 19.9978 2.59706C21.6843 4.38833 21.6843 7.18311 19.9978 8.97437L11.6191 17.8735C11.5545 17.9421 11.4455 17.9421 11.3809 17.8735L3.00218 8.97437C1.31567 7.1831 1.31567 4.38832 3.00218 2.59706C4.8387 0.646478 7.93908 0.646481 9.7756 2.59706Z\" stroke=\"#182037\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol